import React from "react";

export default (props) => {
  const { className, error, ...restProps } = props;

  return (
    <input
      {...restProps}
      className={`custom-input ${error ? "error" : ""} ${className || ""}`}
    />
  );
};
